import { useMutation } from "@tanstack/react-query";
import { type AcceptInviteInput, acceptInvite } from "@/adapters/api";

export function useAcceptInvite(token: string | undefined) {
	return useMutation({
		mutationFn: (input: AcceptInviteInput) =>
			acceptInvite(token as string, input),
	});
}
